import axios from "axios";
import Cookies from "universal-cookie";
import { backendUrl } from "../utils/url";

const cookies = new Cookies();

const api = axios.create({
  baseURL: backendUrl,
  timeout: 5000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${cookies.get("jwt-auth")}`,
  },
});

export const getMyTickets = async () => {
  try {
    const res = await api.get("/ticket/my");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getTicketById = async (ticketId) => {
  try {
    const res = await api.get("/ticket/" + ticketId);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getAllTickets = async () => {
  try {
    const res = await api.get("/ticket/all");
    return res;
  } catch (err) {
    return err.response;
  }
};

export const createTicketMessage = async (data) => {
  try {
    const res = await api.post("/ticketMessage/create", data);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const getTicketMessages = async (ticketId) => {
  try {
    const res = await api.get("/ticketMessage/" + ticketId);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const setPending = async (ticketId) => {
  try {
    const res = await api.put("/ticket/setPending/" + ticketId);
    return res;
  } catch (err) {
    return err.response;
  }
};

export const setAdminAnswered = async (ticketId) => {
  try {
    const res = await api.put("/ticket/setAdminAnswered/" + ticketId);
    return res;
  } catch (err) {
    return err.response;
  }
};
